module.exports = __webpack_public_path__ + "img/team_10_old.08bcb8b6.jpg";